import { useEffect } from "react";
import { API_BASE_URL } from "../apiConfig";

// RFC1918 private ranges + loopback — laptops/dev machines on a LAN or
// docker bridge network, never the public production API.
const PRIVATE_HOST_PATTERN = new RegExp(
  "^(localhost|127\\.|10\\.|192\\.168\\.|172\\.(1[6-9]|2[0-9]|3[0-1])\\.)"
);

function apiHost() {
  try {
    return new URL(API_BASE_URL).hostname;
  } catch {
    return null;
  }
}

// Overrides the tab's favicon with a plain colored dot, drawn as an inline
// SVG so no extra asset file is needed.
function setFaviconDot(color) {
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><circle cx="16" cy="16" r="14" fill="${color}" stroke="#fff" stroke-width="2"/></svg>`;
  let link = document.querySelector("link[rel~='icon']");
  if (!link) {
    link = document.createElement("link");
    link.rel = "icon";
    document.head.appendChild(link);
  }
  link.href = `data:image/svg+xml,${encodeURIComponent(svg)}`;
}

export default function EnvironmentBanner() {
  const isDevBuild = process.env.NODE_ENV === "development";
  const host = apiHost();
  const isLocalApi = host && PRIVATE_HOST_PATTERN.test(host);

  // Tab title + favicon: the thing you actually see while the tab isn't
  // focused, so a dev tab never gets mistaken for the real site at a glance.
  useEffect(() => {
    if (!isDevBuild) return;
    if (!isLocalApi) {
      document.title = `⚠ LIVE DATA — ${document.title}`;
      setFaviconDot("#c0392b");
    } else {
      document.title = `🛠 DEV — ${document.title}`;
      setFaviconDot("#6c757d");
    }
    // deps are constant for the lifetime of the tab — this runs once
  }, []);

  if (!isDevBuild) {
    return null;
  }

  // Dev build talking to a non-local API — most likely the real/live backend.
  // Any create/update/delete click here acts on real data.
  if (!isLocalApi) {
    console.warn(
      `%cDEV BUILD IS CONNECTED TO A LIVE API (${host}) — actions here affect real data.`,
      "color: #fff; background: #c0392b; font-weight: bold; padding: 2px 6px;"
    );
    return (
      <div className="env-banner-danger">
        ⚠ DEV BUILD — CONNECTED TO LIVE API ({host}) — changes here affect REAL data!
      </div>
    );
  }

  // Expected dev setup: dev build against a local API. Just a quiet corner hint.
  return <div className="env-badge-dev">DEV</div>;
}
